"use client";

import {
  AuthProvider as SharedAuthProvider,
  useAuth,
} from "@medly/auth-config/context/AuthProvider";
import { identifyUser } from "../_lib/posthog/analytics";

export function AuthProvider({ children }: { children: React.ReactNode }) {
  return (
    <SharedAuthProvider identifyUser={identifyUser} skipTokenExchange>
      {children}
    </SharedAuthProvider>
  );
}

export { useAuth };
